
import { ReactNode } from 'react';
import Navbar from './Navbar';

interface PublicLayoutProps {
  children: ReactNode;
  /** Si true, no añade padding-top (para páginas con hero a pantalla completa) */
  noTopPadding?: boolean;
}

export default function PublicLayout({ children, noTopPadding = false }: PublicLayoutProps) {
  return (
    <>
      <Navbar />
      <main className={noTopPadding ? '' : 'pt-[88px]'}>
        {children}
      </main>
    </>
  );
}
